// Import FontAwesome essentials
import { IconDefinition } from '@fortawesome/fontawesome-common-types'

const facebookIcon: IconDefinition = {
  prefix: 'fab',
  iconName: 'facebook',
  icon: [
    13,
    24,
    [],
    'f101',
    'M12.0117 13.5L12.6783 9.15656H8.51062V6.33797C8.51062 5.14969 9.09281 3.99141 10.9594 3.99141H12.8541V0.293438C12.8541 0.293438 11.1347 0 9.49078 0C6.05859 0 3.81516 2.08031 3.81516 5.84625V9.15656H0V13.5H3.81516V24H8.51062V13.5H12.0117Z',
  ],
}

const instagramIcon: IconDefinition = {
  prefix: 'fab',
  iconName: 'instagram',
  icon: [
    25,
    24,
    [],
    'f101',
    'M12.2668 5.8467C8.86083 5.8467 6.11353 8.594 6.11353 12C6.11353 15.406 8.86083 18.1533 12.2668 18.1533C15.6728 18.1533 18.4201 15.406 18.4201 12C18.4201 8.594 15.6728 5.8467 12.2668 5.8467ZM12.2668 16.0004C10.0658 16.0004 8.26638 14.2064 8.26638 12C8.26638 9.7936 10.0604 7.99955 12.2668 7.99955C14.4732 7.99955 16.2673 9.7936 16.2673 12C16.2673 14.2064 14.4679 16.0004 12.2668 16.0004ZM20.1071 5.595C20.1071 6.39295 19.4644 7.03024 18.6718 7.03024C17.8739 7.03024 17.2366 6.38759 17.2366 5.595C17.2366 4.80241 17.8792 4.15977 18.6718 4.15977C19.4644 4.15977 20.1071 4.80241 20.1071 5.595ZM24.1825 7.05166C24.0914 5.12909 23.6523 3.42608 22.2438 2.02298C20.8407 0.619882 19.1377 0.180743 17.2152 0.0843468C15.2337 -0.0281156 9.29461 -0.0281156 7.31313 0.0843468C5.39592 0.175388 3.69292 0.614526 2.28446 2.01763C0.876001 3.42073 0.442218 5.12373 0.345821 7.0463C0.233359 9.02778 0.233359 14.9669 0.345821 16.9483C0.436862 18.8709 0.876001 20.5739 2.28446 21.977C3.69292 23.3801 5.39056 23.8193 7.31313 23.9157C9.29461 24.0281 15.2337 24.0281 17.2152 23.9157C19.1377 23.8246 20.8407 23.3855 22.2438 21.977C23.6469 20.5739 24.0861 18.8709 24.1825 16.9483C24.2949 14.9669 24.2949 9.03314 24.1825 7.05166ZM21.6226 19.0744C21.2049 20.1241 20.3963 20.9327 19.3412 21.3558C17.7614 21.9824 14.0127 21.8378 12.2668 21.8378C10.521 21.8378 6.76689 21.977 5.19241 21.3558C4.14276 20.9381 3.33411 20.1294 2.91103 19.0744C2.28446 17.4946 2.42905 13.7458 2.42905 12C2.42905 10.2542 2.28981 6.50006 2.91103 4.92558C3.32875 3.87593 4.13741 3.06728 5.19241 2.6442C6.77224 2.01763 10.521 2.16222 12.2668 2.16222C14.0127 2.16222 17.7668 2.02298 19.3412 2.6442C20.3909 3.06192 21.1996 3.87058 21.6226 4.92558C22.2492 6.50541 22.1046 10.2542 22.1046 12C22.1046 13.7458 22.2492 17.4999 21.6226 19.0744Z',
  ],
}

const linkedInIcon: IconDefinition = {
  prefix: 'fab',
  iconName: 'linkedin',
  icon: [
    25,
    24,
    [],
    'f101',
    'M5.63325 24H0.657424V7.97643H5.63325V24ZM3.14266 5.79066C1.55155 5.79066 0.260986 4.47278 0.260986 2.88167C0.260986 2.1174 0.56459 1.38444 1.10501 0.844022C1.64543 0.303604 2.37839 0 3.14266 0C3.90692 0 4.63989 0.303604 5.18031 0.844022C5.72073 1.38444 6.02433 2.1174 6.02433 2.88167C6.02433 4.47278 4.73323 5.79066 3.14266 5.79066ZM24.2562 24H19.2911V16.1998C19.2911 14.3409 19.2536 11.9569 16.704 11.9569C14.117 11.9569 13.7206 13.9766 13.7206 16.0659V24H8.7501V7.97643H13.5224V10.1622H13.592C14.2563 8.90323 15.879 7.57463 18.3 7.57463C23.3358 7.57463 24.2615 10.8908 24.2615 15.198V24H24.2562Z',
  ],
}

const xIcon: IconDefinition = {
  prefix: 'fab',
  iconName: 'x',
  icon: [
    25,
    24,
    [],
    'f101',
    'M14.7843 10.1624L23.4981 0H21.4332L13.8671 8.82384L7.82398 0H0.854004L9.99232 13.3432L0.854004 24H2.91901L10.9091 14.6817L17.291 24H24.261L14.7838 10.1624H14.7843ZM11.956 13.4608L11.0301 12.1321L3.66306 1.55962H6.83478L12.7801 10.0919L13.706 11.4206L21.4342 22.5113H18.2625L11.956 13.4613V13.4608Z',
  ],
}

const youtubeicon: IconDefinition = {
  prefix: 'fab',
  iconName: 'youtube',
  icon: [
    35,
    24,
    [],
    'f101',
    'M33.687 3.75519C33.2944 2.27706 32.1378 1.11294 30.6692 0.717875C28.0073 0 17.3335 0 17.3335 0C17.3335 0 6.65978 0 3.99785 0.717875C2.52928 1.113 1.37266 2.27706 0.980096 3.75519C0.266846 6.43437 0.266846 12.0243 0.266846 12.0243C0.266846 12.0243 0.266846 17.6141 0.980096 20.2933C1.37266 21.7714 2.52928 22.8871 3.99785 23.2821C6.65978 24 17.3335 24 17.3335 24C17.3335 24 28.0073 24 30.6692 23.2821C32.1378 22.8871 33.2944 21.7714 33.687 20.2933C34.4002 17.6141 34.4002 12.0243 34.4002 12.0243C34.4002 12.0243 34.4002 6.43437 33.687 3.75519ZM13.8426 17.0994V6.94906L22.7638 12.0244L13.8426 17.0994Z',
  ],
}

const tiktokIcon: IconDefinition = {
  prefix: 'fab',
  iconName: 'tiktok',
  icon: [
    14,
    14,
    [],
    'f101',
    'M7.875 0H9.6075C9.7335 0.625625 10.08 1.41488 10.6881 2.198C11.2831 2.96537 12.0724 3.5 13.125 3.5V5.25C11.5911 5.25 10.4388 4.53775 9.625 3.64963V9.625C9.625 10.4903 9.36841 11.3362 8.88768 12.0556C8.40695 12.7751 7.72367 13.3358 6.92424 13.667C6.12482 13.9981 5.24515 14.0847 4.39648 13.9159C3.54782 13.7471 2.76826 13.3304 2.15641 12.7186C1.54456 12.1067 1.12788 11.3272 0.959066 10.4785C0.790256 9.62985 0.876896 8.75019 1.20803 7.95076C1.53916 7.15133 2.09992 6.46805 2.81938 5.98732C3.53885 5.50659 4.38471 5.25 5.25 5.25V7C4.73083 7 4.22331 7.15395 3.79163 7.44239C3.35995 7.73083 3.0235 8.1408 2.82482 8.62046C2.62614 9.10011 2.57415 9.62791 2.67544 10.1371C2.77673 10.6463 3.02673 11.114 3.39385 11.4812C3.76096 11.8483 4.22869 12.0983 4.73789 12.1996C5.24709 12.3008 5.77489 12.2489 6.25455 12.0502C6.7342 11.8515 7.14417 11.5151 7.43261 11.0834C7.72105 10.6517 7.875 10.1442 7.875 9.625V0Z',
  ],
}

const facebookCircle: IconDefinition = {
  prefix: 'fab',
  iconName: 'tiktok',
  icon: [
    14,
    14,
    [],
    'f101',
    'M15.9981 8.04805C15.9981 3.60205 12.4161 -0.00195312 7.99809 -0.00195312C3.57809 -0.000953125 -0.00390625 3.60205 -0.00390625 8.04905C-0.00390625 12.066 2.92209 15.396 6.74609 16V10.375H4.71609V8.04905H6.74809V6.27405C6.74809 4.25705 7.94309 3.14305 9.77009 3.14305C10.6461 3.14305 11.5611 3.30005 11.5611 3.30005V5.28005H10.5521C9.55909 5.28005 9.24909 5.90105 9.24909 6.53805V8.04805H11.4671L11.1131 10.374H9.24809V15.999C13.0721 15.395 15.9981 12.065 15.9981 8.04805Z',
  ],
}

export { facebookCircle, facebookIcon, instagramIcon, linkedInIcon, tiktokIcon, xIcon, youtubeicon }
